export default "__VITE_ASSET__JpeXquJI__"